import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import config from '../config.json';
import {
  useUserContext,
  idExpired,
  id30DaysExpired,
  useAlertContext,
  useFeatureContext,
} from '../common';
import { signout } from '.';
import { compose as lcompose } from 'lodash/fp';
import { left, right, map as emap } from 'fp-ts/lib/Either';

export const useIdExpiration = () => {
  const {
    feature: { idProofReNnroll },
  } = useFeatureContext();
  const { user, setUser } = useUserContext();

  const [expired, setExpired] = useState(false);
  const [expiredIn30Days, setExpiredIn30Days] = useState(false);

  useEffect(() => {
    const now = Date.now();
    lcompose(setExpiredIn30Days, id30DaysExpired(user))(now);
    lcompose(setExpired, idExpired(user))(now);

    lcompose(
      emap(
        lcompose(
          now => {
            lcompose(setExpiredIn30Days, id30DaysExpired(user))(now);
            lcompose(setExpired, idExpired(user))(now);
          },
          () => Date.now()
        )
      ),
      a => (a ? right(void 0) : left(void 0))
    )(idProofReNnroll);
  }, [user, idProofReNnroll]);

  const { setAlert } = useAlertContext();

  useEffect(() => {
    lcompose(
      emap(() =>
        setAlert(a => ({
          ...a,
          title: 'CSOS Id Proof',
          message: () => (
            <>
              <FontAwesomeIcon icon={faTimes} size="1x" fixedWidth />
              {config.idExpired}
            </>
          ),
          okAction: true,
          cancelAction: false,
          isOpen: true,
          onOk: signout(setUser),
        }))
      ),
      expired => (expired ? right(void 0) : left(void 0))
    )(expired);
  }, [expired, setAlert, setUser]);

  useEffect(() => {
    lcompose(
      emap(() =>
        setAlert(a => ({
          ...a,
          title: 'CSOS Id Proof',
          message: () => (
            <>
              <FontAwesomeIcon icon={faTimes} size="1x" fixedWidth />
              {config.id30DayExpired}
            </>
          ),
          okAction: true,
          cancelAction: false,
          isOpen: true,
        }))
      ),
      expiredIn30Days => (expiredIn30Days ? right(void 0) : left(void 0))
    )(expiredIn30Days);
  }, [expiredIn30Days, setAlert]);
};
